import React, { PureComponent } from 'react';
import { Icon } from './elements';

class EliteAndPrimeBanner extends PureComponent {
  render = (): React.ReactElement => {
    return (
      <Icon
        width="130"
        height="34"
        viewBox="0 0 130 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_elite_banner)">
          <path
            d="M1 0L1 26L122.758 26L112.21 13L122.758 0L1 0Z"
            fill="#80C269"
          />
        </g>
        <path
          d="M122.786 0L79.553 26L123 26L112.21 13L122.786 0Z"
          fill="#457C32"
        />
        <path
          d="M16.672 10.968H18.688C19.492 10.968 19.792 10.98 20.224 11.028V9.528C19.768 9.6 19.48 9.612 18.664 9.612H13.324C12.508 9.612 12.22 9.6 11.764 9.528V11.028C12.196 10.98 12.508 10.968 13.3 10.968H15.136V15.9H12.424C11.584 15.9 11.332 15.888 10.864 15.816V17.328C11.296 17.28 11.608 17.268 12.4 17.268H19.6C20.392 17.268 20.704 17.28 21.136 17.328V15.816C20.668 15.888 20.416 15.9 19.576 15.9H16.672V10.968ZM24.448 8.532C24.484 8.844 24.496 9 24.496 9.612V12.912C24.496 13.344 24.472 13.716 24.436 13.992H26.08C26.032 13.692 26.032 13.536 26.032 12.936V9.624C26.032 8.988 26.032 8.88 26.08 8.544L24.448 8.532ZM29.86 8.556C29.908 8.832 29.92 9.084 29.92 9.696V11.196C29.92 12.156 29.908 12.684 29.86 13.2C29.728 14.784 29.332 15.516 28.204 16.26C27.484 16.74 26.788 16.992 25.612 17.22C26.116 17.856 26.236 18.06 26.452 18.648C27.556 18.324 28.156 18.084 28.792 17.724C30.04 17.028 30.808 16.128 31.156 14.928C31.372 14.172 31.456 13.164 31.468 11.292V9.672C31.468 8.988 31.48 8.856 31.528 8.556H29.86ZM34.852 14.232C35.332 14.172 35.464 14.172 36.808 14.172H43.18C44.524 14.172 44.656 14.172 45.136 14.232V12.564C44.608 12.636 44.38 12.648 43.192 12.648H36.796C35.608 12.648 35.38 12.636 34.852 12.564V14.232ZM50.824 18.54C50.788 18.144 50.776 17.832 50.776 17.208V14.04C50.776 13.704 50.764 13.56 50.728 13.224C50.824 13.284 50.86 13.296 51.136 13.428C53.14 14.352 54.388 15.036 55.384 15.72L56.224 14.304C54.304 13.224 52.42 12.348 50.776 11.772V9.54C50.776 8.796 50.776 8.64 50.824 8.28H49.18C49.228 8.604 49.252 8.916 49.252 9.504V17.196C49.252 17.832 49.24 18.156 49.18 18.54H50.824ZM67.012 8.184C67.048 8.46 67.06 8.592 67.06 8.976C67.06 11.352 66.628 13.236 65.764 14.628C64.888 16.044 63.592 17.016 61.48 17.832C61.768 18.168 61.972 18.48 62.248 19.02C64.048 18.264 65.296 17.376 66.268 16.152C66.976 17.292 67.792 18.168 68.848 18.924C69.1 18.36 69.34 17.964 69.688 17.556C68.524 16.872 67.684 16.044 67.072 14.976C67.408 14.376 67.636 13.848 67.828 13.224C68.104 12.3 68.344 10.956 68.404 9.876C68.512 8.34 68.512 8.34 68.524 8.208L67.012 8.184ZM59.752 15.936C59.176 16.152 58.972 16.224 58.552 16.32L58.936 17.784C59.236 17.64 59.32 17.604 59.776 17.4C61.996 16.44 63.004 15.924 64.492 15.012L64.204 13.752C63.4 14.268 62.224 14.892 61.12 15.384L61.06 9.66V9.396C61.06 8.916 61.084 8.556 61.12 8.22H59.596C59.656 8.652 59.68 9.012 59.692 9.648L59.752 15.936ZM62.104 9.648C63.196 10.812 63.484 11.196 64.396 12.708L65.632 11.856C64.744 10.548 64.204 9.876 63.256 8.916L62.104 9.648ZM76.396 12.792H79.216C79.72 12.792 80.176 12.816 80.608 12.864V11.436C80.176 11.484 79.744 11.508 79.216 11.508H76.396V9.456C76.396 8.916 76.42 8.52 76.48 8.076H74.908C74.968 8.568 74.992 8.928 74.992 9.456V17.208H72.256C71.572 17.208 71.068 17.184 70.6 17.136V18.576C71.14 18.516 71.692 18.492 72.256 18.492H79.876C80.476 18.492 80.968 18.516 81.472 18.576V17.136C81.028 17.184 80.488 17.208 79.852 17.208H76.396V12.792Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_elite_banner"
            x="0"
            y="0"
            width="129.758"
            height="34"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="3" dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </Icon>
    );
  };
}

export default EliteAndPrimeBanner;
